import { useState, useEffect } from "react";
import axiosInstance from "../axiosConfig";
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import '../styles/loader.css';
import Loader from "../components/Loader";


const GalleryBox = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await axiosInstance.get('slider/gallery');
        
        if (response.data.success) {
          setGalleryImages(response.data.slider.link_slider_content);
        } else {
          console.error('Gallery data fetch failed:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching gallery data:', error);
      } finally {
        setLoading(false); 
      }
    };

    fetchGalleryData();

    const initMagnificPopup = () => {
      $('.image-link').magnificPopup({
        type: 'image',
        gallery: {
          enabled: false,
        },
        closeOnContentClick: true,
        closeBtnInside: true,
        mainClass: 'mfp-fade',
      });
    };

    if (galleryImages.length > 0) {
      initMagnificPopup();
    }
  }, [galleryImages.length]);


  if (loading) {
      return <Loader />;
  }
  
  return (
    <section className="gallery no-top no-bottom">
      <div className="container-fluid">
        <div className="row">
          {galleryImages.map((image, index) => (
            <div className="col-md-6 col-lg-4 mb-24" key={index}>
              <div className="de-image-hover">
                <a href={image.image} className="image-link">
                  <span className="dih-title-wrap">
                    <span className="dih-title">{image.title}</span>
                  </span>
                  <span className="dih-overlay"></span>
                  <img
                    src={image.image}
                    className="lazy img-fluid"
                    alt={image.title}
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryBox;